import { AES, enc, lib } from 'crypto-js';

import { environment } from '@env/environment';

const defaultSecret = environment.cypherSecret;

export function encrypt<T = unknown>(data: T, secret = defaultSecret): string {
  return AES.encrypt(JSON.stringify(data), secret).toString();
}

export function encryptObfuscated<T = unknown>(
  data: T,
  secret = defaultSecret
): string {
  const encrypted = encrypt(data, secret);

  // Gera ruído com caracteres seguros
  const prefix = generateRandomString(8).replace(/[+/=]/g, '');
  const suffix = generateRandomString(6).replace(/[+/=]/g, '');

  // Cria o payload
  const combined = `${prefix}__${encrypted}__${suffix}`;

  // Converte para Base64 URL-safe
  const base64 = enc.Base64.stringify(enc.Utf8.parse(combined))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

  return base64;
}

export function decrypt<T = unknown>(
  ciphertext: string,
  secret = defaultSecret
): T {
  if (typeof ciphertext !== 'string') {
    throw new Error('Ciphertext must be a string');
  }
  const bytes = AES.decrypt(ciphertext, secret);
  return JSON.parse(bytes.toString(enc.Utf8)) as T;
}

export function decryptObfuscated<T = unknown>(
  obfuscated: string,
  secret = defaultSecret
): T {
  try {
    const base64 =
      obfuscated.replace(/-/g, '+').replace(/_/g, '/') +
      '=='.slice(0, (3 - (obfuscated.length % 4)) % 3);

    const decoded = enc.Base64.parse(base64).toString(enc.Utf8);

    const parts = decoded.split('__');
    if (parts.length !== 3) {
      throw new Error('Formato inválido');
    }

    return decrypt(parts[1], secret);
  } catch (error) {
    console.error('Erro na descriptografia:', error);
    throw new Error('Invalid data or corrupted data');
  }
}

function generateRandomString(length: number): string {
  return lib.WordArray.random(length)
    .toString()
    .replace(/[+/=]/g, '')
    .slice(0, length);
}
